module.exports = __webpack_public_path__ + "static/media/2.b98b160a.jpg";